<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M4.667 13.333 2 10.667 4.667 8l.95.933L4.55 10h2.783v1.333H4.55L5.6 12.4zm4.666-2a.65.65 0 0 1-.475-.191.65.65 0 0 1-.191-.475q0-.285.191-.475A.65.65 0 0 1 9.333 10q.285 0 .475.192a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191m2.667 0a.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475q0-.285.192-.475A.65.65 0 0 1 12 10q.283 0 .475.192a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191M11.333 8l-.95-.933L11.45 6H8.667V4.667h2.783L10.4 3.6l.933-.933L14 5.333zM4 6a.65.65 0 0 1-.475-.192.65.65 0 0 1-.192-.475q0-.283.192-.475A.65.65 0 0 1 4 4.667q.283 0 .475.191a.65.65 0 0 1 .192.475.65.65 0 0 1-.192.475A.65.65 0 0 1 4 6m2.667 0a.65.65 0 0 1-.475-.192A.65.65 0 0 1 6 5.333q0-.283.192-.475a.65.65 0 0 1 .475-.191q.283 0 .475.191a.65.65 0 0 1 .191.475.65.65 0 0 1-.191.475.65.65 0 0 1-.475.192"
        />
    </svg>
</template>

<script setup lang="ts">
type MultipleStopIconProps = {
    ariaLabelledby?: string;
};
const props = defineProps<MultipleStopIconProps>();
</script>
